import React, { useEffect } from "react"
import Section from "../../../../core/layout/main/section/Section"
import { arrayToHtml } from "../../../../../utils/editorJsLib"
import Card from "../../blocks/card/Card"
import Icon from "../../blocks/icon/Icon"
import * as classNames from "./CtxArticleViewerSection.module.scss"
import ShareBlock from "../../blocks/shareBlock/ShareBlock"
import Button from "../../blocks/button/Button"

const CtxArticleViewerSection = ({ headers, html, pageContext }) => {
  const pdfFile =
    pageContext.itemData.attributes?.pdfDeCommunique?.data?.attributes.url
  const pdfUrl = pageContext.itemData?.attributes?.urlPdfDeCommunique

  useEffect(() => {
    const elementsToLoadIn = document.querySelectorAll("h2[id]")
    const observerOptions = {
      root: null,
      rootMargin: "0% 0% -10% 0%",
      threshold: 0.1,
    }
    function observerCallback(entries) {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute("id")
        const sel = document.querySelector(`a[href="#${id}"]`)
        if (sel) {
          if (entry.isIntersecting) {
            document.querySelector(`a[href="#${id}"]`).classList.add("active")
          } else {
            document
              .querySelector(`a[href="#${id}"]`)
              .classList.remove("active")
          }
        }
      })
    }
    const observer = new IntersectionObserver(observerCallback, observerOptions)
    elementsToLoadIn.forEach((el) => observer.observe(el))
  }, [])

  const url = typeof window !== "undefined" ? window.location.href : ""
  return (
    <Section
      className={classNames.article}
      container="large"
    >
      <div className={classNames.gridContainer}>
        <div className={classNames.navigation}>
          <Card className="p-3">
            <details open>
              <summary>
                Contenu
                <Icon
                  icon="arrow"
                  width="16"
                  height="16"
                  color="var(--gris)"
                  onClick={() => {
                    const details = document.querySelector("details")
                    if (details.hasAttribute("open")) {
                      details.removeAttribute("open")
                    } else {
                      details.setAttribute("open", "")
                    }
                  }}
                />
              </summary>
              <nav>
                <ol>
                  {headers.map((header, i) => (
                    <li key={i}>
                      <a
                        href={"#" + header.id}
                        dangerouslySetInnerHTML={{ __html: header.data.text }}
                      ></a>
                    </li>
                  ))}
                </ol>
              </nav>
            </details>
          </Card>
          <ShareBlock
            url={url}
            className="mt-3"
          />
          {pdfFile || pdfUrl ? (
            <div className="mt-3">
              <Button
                aspect="contrastant"
                size="small"
                color="primary"
                to={
                  pageContext.itemData.attributes.pdfDeCommunique.data
                    ? pdfFile
                    : pdfUrl
                }
                target="_blank"
                className={"fluid"}
              >
                Télécharger le communiqué
              </Button>
            </div>
          ) : null}
        </div>
        <article
          className={classNames.template}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </Section>
  )
}

export const name = "CtxArticleViewerSection"

export const init = (componentData, pageContext) => {
  const blocks = pageContext.itemData.attributes.contentEditorJs
    ? JSON.parse(pageContext.itemData.attributes.contentEditorJs)
    : []
  const headers = blocks.filter((i) => i.data.level === 2)
  const html = arrayToHtml(blocks)
  return (
    <CtxArticleViewerSection
      key={componentData.id}
      headers={headers}
      html={html}
      pageContext={pageContext}
    />
  )
}

export default CtxArticleViewerSection
